import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AuthGuard } from '../shared/auth/auth.guard';
import { ConfigurationsDetailComponent } from './configurations-detail/configurations-detail.component';
import { ConfigurationsComponent } from './configurations.component';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'configurations',
        canActivate: [AuthGuard],
        component: ConfigurationsComponent,
        children: [
          {
            path: ':id',
            component: ConfigurationsDetailComponent,
          }
        ],
      }
    ])
  ],
  exports: [RouterModule]
})
export class ConfigurationsRoutingModule {}



// WEBPACK FOOTER //
// /ng-app/src/app/configurations/configurations.routing.module.ts